export default __webpack_public_path__ + "static/media/905.5524a501.png";